import React from "react";

const AvatarOptions = ({
  options,
  selectedOption,
  onSelect,
}) => {
  // Categoria nu are inca elemente
  if (!options || options.length === 0) {
    return (
      <div className="avatar-options-empty">
        <p>Optiuni disponibile in curand.</p>
      </div>
    );
  }

  return (
    <div className="avatar-options">
      {options.map((option) => {
        const isSelected = selectedOption === option.id;

        return (
          <button
            key={option.id}
            type="button"
            className={`avatar-option ${
              isSelected ? "avatar-option-selected" : ""
            }`}
            onClick={() => onSelect(option.id)}
            aria-label={option.name}
            aria-pressed={isSelected}
          >
            <div className="avatar-option-image-container">

              {/* OPTIUNE CU IMAGINE */}
              {option.image && (
                <img
                  src={option.image}
                  alt={option.name}
                  className="avatar-option-image"
                />
              )}

              {/* OPTIUNE CU CULOARE */}
              {option.color && (
                <div
                  className="avatar-option-color"
                  style={{
                    backgroundColor: option.color,
                  }}
                />
              )}

            </div>

            <span className="avatar-option-name">
              {option.name}
            </span>

            {isSelected && (
              <span className="avatar-option-check">
                ✓
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default AvatarOptions;